import { useState } from "react";
import TextInput from "../Common/text_input";
import DraftLayout from "../Common/draftLayout";
import CheckBoxInput from "../Common/checkbox_input";
import { useDispatch, useSelector } from "react-redux";
import { nextStep, prevStep, updateDraft, updateDraftField } from "redux/draft";

function Chapter5CLinkedin() {
  const dispatch = useDispatch();
  const details = useSelector((state) => state?.draft?.details);

  const [website, setWebsite] = useState(
    details?.socialsPresence?.linkedIn?.name
  );
  const [number, setNumber] = useState(
    details?.socialsPresence?.linkedIn?.number
  );

  return (
    <DraftLayout
      heading="Professional Network Presence"
      subheading="Assess the company’s LinkedIn footprint"
      info="Information on where to find this"
      chapName="Digital Footprint"
      onNext={() => {
        dispatch(
          updateDraft({
            value: {
              socialsPresence: {
                ...details?.socialsPresence,
                linkedIn: { name: website, number: number },
              },
            },
          })
        );
        dispatch(updateDraftField({ field: "linkedIn", value: website }));
        dispatch(nextStep());
      }}
      onPrevious={() => dispatch(prevStep())}
      bottomDisabled={false}
    >
      <main className="my-10 flex flex-col gap-10 items-center w-full">
        <TextInput
          value={website}
          onChange={(e) => {
            setWebsite(e.target.value);
          }}
          label="LinkedIn Address"
          placeholder="LinkedIn address here"
        />
        <TextInput
          value={number}
          onChange={(e) => {
            setNumber(e.target.value);
          }}
          label="No. of Followers on LinkedIn"
          placeholder="100"
        />
        <h3 className="font-lato text-2xl font-light">or</h3>
        <CheckBoxInput text="Company is not on LinkedIn" onChange={(e) => {}} />
      </main>
    </DraftLayout>
  );
}

export default Chapter5CLinkedin;
